import i18n from "i18next";
import { ALL_COUNTRY } from "../globals";

export const currencyCode = (countryCode: string) => {
    switch (countryCode) {
        case "DE": case "AT":
            return "EUR";
        case "CH": case "ALL":
            return "CHF";
        default:
            return "";
    }
};

export const formatCurrencyCode = (countryCode: string) => {
    const code = currencyCode(countryCode);
    if (!code) {
        return "";
    } else {
        return `(${code})`
    }
};

export const formatCurrency = (value: number, countryCode: string, decimalPlaces: number = 2) => {
    if(countryCode === ALL_COUNTRY) {
        countryCode = 'CH';
    } 
    const locale = `${i18n.language}-${countryCode}`;

    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    }).format(value);
};